//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';
import { PojoSet } from 'pojo-sets';

import { IFacebookPageSuggestion } from '@components/molecules/smart-input/smartInputModel';
import FacebookPageId from '@models/FacebookPageId';

export interface IFacebookPageDetails {
  pageMetadata: IFacebookPageMetadata;
  isClientOnboarded: boolean;
  flags: IFacebookPageFlags;
}

export interface IFacebookPages {
  data: Record<string, IFacebookPageSuggestion[]>;
}

export interface ITaggedFacebookPages {
  data: PojoMap<FacebookPageId, IFacebookPageSuggestion>;
  invalidPages: PojoMap<FacebookPageId, string>;
}

export interface IFacebookPageMetadata {
  biography?: string;
  profilePictureUrl?: string;
  username?: string;
}

interface IFacebookPageFlags {
  hasMissingPageId: boolean;
  isFetchingPageMetadata: boolean;
  isFetchingFacebookAndInstagramConnectionInfo: boolean;
  isFetchingFacebookPageConnectionInfo: boolean;
  isSettingOnboarded: boolean;
}

export interface IFacebookPageErrors {
  initialPostDetailsError: string | undefined;
  getPagesSearchErrors: string[];
  getPageByIdErrors: string[];
  schedulePostErrors: string[];
  scheduleDraftErrors: string[];
  shortLinkErrors: string[];
  validationErrors: PojoSet<FacebookPostDetailsValidationError>;
}

export enum FacebookPostDetailsValidationError {
  ImageTooLarge = 'ImageTooLarge',
  NoMediaOrLink = 'NoMediaOrLink',
  NoPostTime = 'NoPostTime',
  OriginalScheduledTimeInPast = 'OriginalScheduledTimeInPast',
  PostTimeInPast = 'PostTimeInPast',
  VideoTooLong = 'VideoTooLong',
}
